import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateFn, GuardResult, MaybeAsync, Router, RouterStateSnapshot } from '@angular/router';
import { catchError, combineLatest, map, Observable, of, switchMap } from 'rxjs';
import { QuotationPathEnum } from 'src/app/enums/quotation.enum';
import { CloudNotificationStyle } from 'src/app/models/cloud-notification-style.model';
import { User } from 'src/app/models/user.model';
import { QuotationService } from 'src/app/paid-subscription/services/quotation.service';
import { CloudNotificationService } from 'src/app/services/cloud-notification.service';
import { CloudProfileService } from 'src/app/services/cloud-profile.service';
import { QuotationDetails } from 'src/app/types/quotation.type';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ValidGuard implements CanActivate {

  constructor(
    private readonly userService: CloudProfileService,
    private readonly quotationService: QuotationService,
    public router: Router,
    private readonly notificationService:CloudNotificationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const quotationId = route.queryParams['quotationId'];
    const fromPath = route.queryParams['frompath']

    if (!quotationId) {
      return of(true);
    }
    if(fromPath == '' || fromPath == undefined || (fromPath != QuotationPathEnum.BUY_NCACHE && fromPath != QuotationPathEnum.EMAIL_LINK && fromPath != QuotationPathEnum.TRANSACTION_LINK)){
      this.notificationService.createToastNotification("Valid Guard","Incorrect Url",CloudNotificationStyle.danger)
      this.router.navigate([environment.routes.subscription]);
      return of(false)
    }

    return this.getUser().pipe(
      switchMap(user =>
        combineLatest([of(user), this.getQuotationDetails(quotationId)])
      ),
      map(([user, quotation]) => {
        if (user && quotation && user.email == quotation.subscription.userEmail) {
          return true;
        }
        this.notificationService.createToastNotification("Valid Guard","The requested quotation does not exist or is not associated with your account.",CloudNotificationStyle.danger)
        this.router.navigate([environment.routes.subscription]);
        return false;
      }),
      catchError(error => {
        this.notificationService.createToastNotification("Valid Guard","The requested quotation does not exist or is not associated with your account.",CloudNotificationStyle.danger)
        this.router.navigate([environment.routes.subscription]);
        return of(false);
      })
    );
  }

  private getUser(): Observable<User> {
    return this.userService.getUserDetails().pipe(
      catchError(error => {
        return of(null);
      })
    );
  }

  private getQuotationDetails(quotationId: string): Observable<QuotationDetails> {
    return this.quotationService.getQuotationByQuotationId(quotationId).pipe(
      catchError(error => {
        return of(null);
      })
    );
  }
}